module.exports = __webpack_public_path__ + "static/media/7.897daf3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/7.png
// module id = 2114
// module chunks = 0